/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NextPortCluster } from './NextPortCluster';
import {
    NextPortClusterFromJSON,
    NextPortClusterFromJSONTyped,
    NextPortClusterToJSON,
} from './NextPortCluster';

/**
 * 
 * @export
 * @interface NextportClusterGet200Response
 */
export interface NextportClusterGet200Response {
    /**
     * 
     * @type {Array<NextPortCluster>}
     * @memberof NextportClusterGet200Response
     */
    records: Array<NextPortCluster>;
}

/**
 * Check if a given object implements the NextportClusterGet200Response interface.
 */
export function instanceOfNextportClusterGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "records" in value;

    return isInstance;
}

export function NextportClusterGet200ResponseFromJSON(json: any): NextportClusterGet200Response {
    return NextportClusterGet200ResponseFromJSONTyped(json, false);
}

export function NextportClusterGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextportClusterGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': ((json['records'] as Array<any>).map(NextPortClusterFromJSON)),
    };
}

export function NextportClusterGet200ResponseToJSON(value?: NextportClusterGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': ((value.records as Array<any>).map(NextPortClusterToJSON)),
    };
}

